/* 22.10 (A9, W-45): komunikaty dostępności karuzel (Swiper) z pliku języka zamiast domyślnych angielskich
   („Previous slide”, „Next slide”, „1 / 10”). Plik ładowany z defer PO libs.min.js i PRZED global.min.js
   (layout/theme.liquid), więc ustawia domyślne wartości, zanim motyw utworzy pierwszą karuzelę. Napisy przychodzą
   w atrybutach data-* znacznika script (Liquid, klucze accessibility.* i pg.karuzela.*). Ustawienia podane wprost
   przy karuzeli (np. section-locations: slideLabelMessage "") mają pierwszeństwo, jak w Swiperze. */
(function () {
  var s = document.currentScript;
  if (!s || !window.Swiper || typeof window.Swiper.extendDefaults !== 'function') return;
  var d = s.dataset; var a11y = {};
  var mapa = { prev: 'prevSlideMessage', next: 'nextSlideMessage', first: 'firstSlideMessage', last: 'lastSlideMessage', bullet: 'paginationBulletMessage', slide: 'slideLabelMessage' };
  // Liquid nie może przekazać nawiasów klamrowych w argumencie t, więc __I__ i __N__ zamieniam tu na znaczniki Swipera
  for (var k in mapa) { if (d[k]) a11y[mapa[k]] = d[k].split('__I__').join('{{index}}').split('__N__').join('{{slidesLength}}'); }
  window.Swiper.extendDefaults({ a11y: a11y });
})();
